import { type EditorNavSection, EditorSectionNav } from "@/components/EditorSectionNav/EditorSectionNav";

export type ProductEditorSection = EditorNavSection;

export interface ProductEditorSectionsViewProps {
  sections: ProductEditorSection[];
  title: string;
}

/**
 * Presentational section navigation for the product editor index. Renders each
 * editable section (title, tagline, description, photos, content, pricing) as a
 * navigable tile. The surrounding editor chrome — sidebar header, top bar and
 * mobile navigation — is supplied by `EditFrame` in the container.
 */
export function ProductEditorSectionsView({ sections, title }: ProductEditorSectionsViewProps) {
  return <EditorSectionNav ariaLabel={title} sections={sections} />;
}
